var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import LinkToggle from '../link/LinkToggle';
export var useHiddenLinksLogic = function (filterableLinkTypes) {
    var _a = useState([]), hiddenLinkTypes = _a[0], setHiddenLinkTypes = _a[1];
    var onToggle = function (toggledLinkType) {
        if (hiddenLinkTypes.includes(toggledLinkType)) {
            setHiddenLinkTypes(hiddenLinkTypes.filter(function (hiddenLinkType) { return hiddenLinkType !== toggledLinkType; }));
        }
        else {
            setHiddenLinkTypes(__spreadArray(__spreadArray([], hiddenLinkTypes, true), [toggledLinkType], false));
        }
    };
    var toggleComponent = filterableLinkTypes.length > 0 ? (React.createElement(LinkToggle, { allOptions: filterableLinkTypes, selectedOptions: filterableLinkTypes.filter(function (linkType) { return !hiddenLinkTypes.includes(linkType); }), onToggle: onToggle })) : null;
    return {
        toggleComponent: toggleComponent,
        hiddenLinkTypes: hiddenLinkTypes,
    };
};
//# sourceMappingURL=hideLinks.js.map